module.exports = __webpack_public_path__ + "img/banner-header-new_01-seguros-venta-y-asesoria.edbaac42.jpg";